export default {
  title: {
    text: "全球半导体材料市场规模细分",
    left: "center",
  },
  color: [
    "#64fffd",
    "#5d0799",
    "#57d1ef",
    "#9737c6",
    "#46b3b7",
    "#dc96f4",
    "#243bc1",
    "#72a0f9",
    "#2f5fc1",
  ],
  tooltip: {
    trigger: "axis",
    axisPointer: {
      type: "cross",
      crossStyle: {
        color: "#999",
      },
    },
  },
  grid: {
    top: 350,
  },
  toolbox: {
    feature: {
      dataView: { show: false, readOnly: false },
      magicType: { show: false, type: ["line", "bar"] },
      restore: { show: false },
    },
  },

  legend: {
    top: 120,
    left: "center",
    data: [
      "硅片",
      "光掩膜",
      "光刻胶",
      "光刻胶辅材",
      "湿化学品",
      "电子气体",
      "靶材",
      "CMP材料",
      "其他材料",
    ],
  },
  xAxis: [
    {
      type: "category",
      data: ["2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020"],
      axisPointer: {
        type: "shadow",
      },
      axisLabel: {
        show: true,
        fontSize: 30,
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "市场价值/百万美元",
      min: 0,
      max: 40000,
      interval: 10000,
      axisLabel: {
        formatter: "{value}",
      },
    },
    {
      type: "value",
      name: "增长率/%",

      min: -15,
      max: 25,
      interval: 10,
      axisLabel: {
        formatter: "{value}",
        textStyle: {
          fontSize: 40,
        },
      },
    },
  ],
  series: [
    {
      name: "硅片",
      type: "bar",
      stack: "材料",
      barWidth: 30,
      data: [
        7938.549,
        7853.646,
        7109.706,
        7643.321,
        8963.567,
        11649.11,
        11905.02,
        12040.6,
      ],
    },
    {
      name: "光掩模",
      type: "bar",
      stack: "材料",
      data: [
        3238.577,
        3328.569,
        3298.524,
        3267.882,
        3840.109,
        4292.309,
        4021.15,
        4593.515,
      ],
    },
    {
      name: "光刻胶",
      type: "bar",
      stack: "材料",
      data: [
        1182.357,
        1332.708,
        1601.93,
        1633.971,
        1658.177,
        1918.704,
        1948.854,
        1736.885,
      ],
    },
    {
      name: "光刻胶辅材",
      type: "bar",
      stack: "材料",
      data: [
        1505.607,
        1833.797,
        1921.306,
        1773.347,
        2097.092,
        2057.24,
        1668.176,
        2115.26,
      ],
    },
    {
      name: "湿化学品",
      type: "bar",
      stack: "材料",
      data: [
        820.772,
        854.797,
        1009.891,
        1637.934,
        2043.061,
        2454.682,
        2723.754,
        2639.017,
      ],
    },
    {
      name: "电子气体",
      type: "bar",
      barWidth: 45,
      stack: "材料",
      data: [
        3191.915,
        3415.103,
        3037.622,
        3382.885,
        3600.217,
        3814.143,
        4039.352,
        3901.75,
      ],
    },
    {
      name: "靶材",
      type: "bar",
      stack: "材料",
      data: [
        720.721,
        720.72,
        1081.081,
        720.72,
        960.961,
        1081.082,
        720.72,
        1081.08,
      ],
    },
    {
      name: "CMP材料",
      type: "bar",
      stack: "材料",
      data: [
        1494.504,
        1476.67,
        1699.012,
        1803.6,
        1539.712,
        2231.187,
        2216.733,
        1958.955,
      ],
    },
    {
      name: "其他材料",
      type: "bar",
      stack: "材料",
      barWidth: 18,
      data: [
        2521.968,
        2896.564,
        3031.348,
        2926.76,
        3061.536,
        3196.156,
        3211.33,
        3825.153,
      ],
    },
    {
      name: "增长率",
      type: "line",
      itemStyle: {
        normal: {
          borderWidth: 2,
        },
      },
      lineStyle: {
        normal: {
          width: 6,
        },
      },
      symbolSize: 14,
      yAxisIndex: 1,
      smooth: "true",
      data: [
        "undefined",
        5.8532934,
        3.8323352,
        -0.35928145,
        12.51497,
        17.15569,
        -0.43413174,
        4.056886,
      ],
    },
  ],
};
